/* ==========================================================================
  Bb cross Game Constants
========================================================================== */
export const MIN_MINE_COUNT = 1
export const MAX_MINE_COUNT = 10
export const MIN_TILE_COUNT = 1
export const MAX_TILE_COUNT = 24
export const DEFAULT_MINE_COUNT = 3
export const DEFAULT_MINE_GAME_AUTOBET_ROUNDS = '∞'

export const DEFAULT_DIFFICULTY_VALUE = 1

// export const LANE_MINE_TILE_COUNT =  { 1: 25, 2: 22, 3: 20, 4: 15 }

// export const LANE_MINE_COUNT = { 1: 1, 2: 3, 3: 4, 4: 8 }

// export const LANE_MINE_FIXED_ODDS = {
//   1: [1, 1.04, 1.09, 1.12, 1.16, 1.21, 1.27, 1.35, 1.43, 1.51, 1.70, 1.77, 1.90, 2.08, 2.26, 2.45, 2.88, 3.05, 3.34, 3.60, 5.07, 5.80, 9.00, 17, 24],
//   2: [1.09, 1.25, 1.48, 1.75, 2.01, 2.48, 2.91, 3.14, 3.47, 4.99, 6.07, 7.88, 10.24, 14.38, 19.40, 27.29, 39.43, 63.09, 110.40, 220.80, 552, 2208],
//   3: [1.20, 1.35, 1.50, 2.30, 2.95, 4.05, 5.19, 7.01, 9.20, 13.00, 19.14, 28.23, 48.40, 87.40, 119.40, 280.80, 500.80, 1430.80, 4500.80, 25004.80],
//   4: [1.60, 2.74, 7.85, 13.90, 22.98, 40.97, 78.71, 161.35, 391.86, 1044.96, 3134.87, 10972.06, 47545.60, 285273.60, 3138009.60]
// }

// export const TABS = {
//   ALL_BETS: 'ALL_BETS',
//   TOP_BETS: 'TOP_BETS'
// }




//************* NEW CODE ******************* */


// Mirrors backend CROSS_POOL_SIZE (src/libs/constants.js): ONE universal
// probability pool (25 lanes) for every difficulty. Only the mine count
// differs. Used by calculateLaneMineOdd (bbCross.helper.js) to compute the
// SAME hypergeometric odds as the backend.
export const LANE_MINE_POOL_SIZE = 25

// The real, per-difficulty PLAYABLE lane count = pool - mines (mirrors backend
// CROSS_PLAYABLE_LANE). This is what's actually shown/openable on the board —
// the pool's remaining lanes are never displayed or opened; reaching this
// count triggers the backend's auto-finish (see Rencana Backend / Frontend in
// the plan doc). Previously this held the OLD per-difficulty pool
// (25/22/20/15); Easy is the only value that changes (25->24) since Medium/
// Hard/Crazy's NEW playable count happens to equal their OLD pool value.
export const LANE_MINE_TILE_COUNT = { 1: 24, 2: 22, 3: 20, 4: 15 }

// Mine count per difficulty, matched to Pragmatic Play exactly (mirrors
// backend CROSS_COUNT): Easy 1, Medium 3, Hard 5, Crazy 10 (previously
// 1/3/4/8 — Hard and Crazy updated).
export const LANE_MINE_COUNT = { 1: 1, 2: 3, 3: 5, 4: 10 }

// LANE_MINE_FIXED_ODDS (hardcoded manual table) removed — it had the same
// confirmed bug as the backend's old CROSS_FIXED_ODDS (Easy's array had a
// stray leading 1.00, shifting every step by one). Odds are now computed on
// the fly in calculateLaneMineOdd (bbCross.helper.js) via the same
// hypergeometric formula as the backend, so the board can never show a number
// different from what the backend actually pays.

export const TABS = {
  ALL_BETS: 'ALL_BETS',
  TOP_BETS: 'TOP_BETS'
}
